import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface ReviewModalProps {
  username: string;
  spId: string;
  onClose: () => void;
  onSubmit: (rating: number, comment: string) => void;
  currentRating?: number;
  currentComment?: string;
}

const ReviewModal: React.FC<ReviewModalProps> = ({ 
  username, 
  spId,
  onClose, 
  onSubmit,
  currentRating = 0,
  currentComment = ''
}) => {
  const [rating, setRating] = useState<number>(currentRating);
  const [comment, setComment] = useState<string>(currentComment);
  const maxCharacters = 500;

  const handleSubmit = () => {
    onSubmit(rating, comment);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-[9999]">
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="relative bg-white rounded-lg p-8 w-full max-w-md mx-4">
        <h2 className="text-4xl text-primary font-bold mb-4">Write a Review</h2>
        <p className="text-xl text-gray-600 mb-6">
          Share your experience with {username}
        </p>
        
        <div className="mb-6">
          <div className="flex items-center mb-2">
            {[1, 2, 3, 4, 5].map((star) => (
              <div 
                key={star} 
                className="text-4xl text-primary cursor-pointer mr-2"
                onClick={() => setRating(star)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    setRating(star);
                  }
                }}
                tabIndex={0}
                role="button"
                aria-label={`Rate ${star} stars`}
              >
                <FontAwesomeIcon 
                  icon={faStar}
                  className={star <= rating ? "text-yellow-400" : "text-gray-300"}
                />
              </div>
            ))}
            <span className="ml-2 text-xl text-gray-600">Select your rating</span>
          </div>
        </div>
        
        <div className="mb-6">
          <textarea
            className="w-full border border-primary rounded-lg p-4 h-40"
            placeholder="Write your review here..."
            value={comment}
            onChange={(e) => {
              if (e.target.value.length <= maxCharacters) {
                setComment(e.target.value);
              }
            }}
          />
          <div className="text-right text-gray-500">
            {comment.length}/{maxCharacters} characters
          </div>
        </div>
        
        <div className="flex justify-end">
          <button
            className="bg-primary text-white text-xl py-3 px-8 rounded-full disabled:opacity-50"
            onClick={handleSubmit}
            disabled={rating === 0}
          >
            Submit Review
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReviewModal;